import { Injectable } from '@angular/core';
import { INavData } from '@coreui/angular-pro';
import { MenuModel } from '@domain/models/general/menu.model';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class CustomMenuService {
  private menuItems: Array<any> = [
    {
      name: 'CATALOGOS',
      icon: 'fa-solid fa-list',
      children: [

        {
          name: 'Maestro de Socios',
          icon: 'fa-solid fa-users',
          url: '/catalog/maestro-socios',
          permission: 'MAESTRO_SOCIOS-VER',
        },
        {
          name: 'Bancos',
          icon: 'fa-solid fa-building-columns',
          url: '/catalog/bancos',
          permission: 'BANCOS-VER',
        },
        {
          name: 'Sucursales',
          icon: 'fa-solid fa-building',
          url: '/catalog/sucursales',
          permission: 'SUCURSALES-VER',
        },
        {
          name: 'Plantas',
          icon: 'fa-solid fa-industry',
          url: '/catalog/plantas',
          permission: 'PLANTAS-VER',
        },
        {
          name: 'Tipo de desvios',
          url: '/catalog/tipo-desvio',
          icon: "fa-solid fa-arrows-turn-right",
          permission: 'TIPO_DESVIOS-VER',
        },
        {
          name: 'Relaciones de Pago',
          icon: "fa-solid fa-file-invoice-dollar",
          url: '/catalog/relaciones-pago',
          permission: 'RELACIONES_PAGOS-VER',
        },
        {
          name: 'Regiones',
          icon: "fa-solid fa-map-location",
          url: '/catalog/regiones',
          permission: 'REGIONES-VER',
        },
        {
          name: 'Compañias Transportistas',
          icon: "fa-solid fa-truck-arrow-right",
          url: '/catalog/companiaTranportista',
          permission: 'COMPAÑIA_TRANSPORTISTA-VER',
        },
        {
          name: 'Regiones de Recolección',
          icon: "fa-solid fa-location-crosshairs",
          url: '/catalog/regiones-recoleccion',
          permission: 'REGIONES_RECOLECCION-VER',
        },
        {
          name: 'Rutas',
          icon: "fa-solid fa-road",
          url: '/catalog/rutas',
          permission: 'RUTAS-VER',
        },
        {
          name: 'Movimientos de Recolección',
          icon: "fa-solid fa-up-down-left-right",
          url: '/catalog/movimientosRecoleccion',
          permission: 'MOVIMIENTOS_RECOLECCION-VER',
        },
        {
          name: 'Tanques',
          icon: "fa-solid fa-boxes-stacked",
          url: '/catalog/tanques',
          permission: 'TANQUES-VER',
        },
        {
          name: 'Agrupación de Rutas por Mov.Rec.',
          icon: "fa-solid fa-arrows-to-circle",
          url: '/catalog/rutasMovimientoRecoleccion',
          permission: 'RUTAS_MOVIMIENTOS-VER',
        },
        {
          name: 'Conceptos',
          icon: "fa-solid fa-circle-nodes",
          url: '/catalog/conceptos',
          permission: 'CONCEPTOS-VER',
        },
        {
          name: 'Control Concep.Cia.',
          icon: "fa-solid fa-users-rays",
          url: '/catalog/control-concep-cia',
          permission: 'CONCEPTO_CIA-VER',
        },
        {
          name: 'Veterinarios',
          icon: "fa-solid fa-shield",
          url: '/catalog/vet',
          permission: 'VETERINARIOS-VER',
        },
      ]
    },

    {
      name: 'LIQUIDACIÓN',
      icon: 'fa-solid fa-coins',
      children: [
        {
          name: 'Mantenimiento de Acciones y Topes',
          icon: 'fa-solid fa-dollar-sign',
          children: [
            {
              name: 'Mantenimiento acciones',
              url: '/mantenimiento/acciones',
              icon: "fa-solid fa-money-bill-trend-up",
              permission: 'MANTENIMIENTO_ACCIONES-VER',
            },
            {
              name: 'Mantenimiento contratos',
              url: '/mantenimiento/contratos',
              icon: "fa-solid fa-file-contract",
              permission: 'MANTENIMIENTO_CONTRATOS-VER',
            },
            {
              name: 'Mantenimiento litros por accion',
              icon: "fa-solid fa-bottle-water",
              url: '/mantenimiento/litros',
              permission: 'MANTENIMIENTO_LITROS_ACCION-VER',
            },
            {
              name: 'Topes por día',
              url: '/mantenimiento/topes/dia',
              icon: "fa-solid fa-bars",
              permission: 'TOPES_DIA-VER',
            },
            {
              name: 'Topes por semana',
              icon: "fa-solid fa-bars",
              url: '/mantenimiento/topes/semana',
              permission: 'TOPES_SEMANA-VER',
            },
          ],
        },
        {
          name: 'Maestro de Precios',
          icon: "fa-solid fa-comment-dollar",
          children: [
            {
              name: 'Mantenimiento de Precios Componentes',
              icon: "fa-solid fa-money-bill",
              url: '/mantenimiento/precios-componentes',
              permission: 'PRECIOS_COMPONENTES-VER',
            },
            {
              name: 'Precio Componente Promedio Semanal',
              icon: "fa-solid fa-money-bills",
              url: '/mantenimiento/precios-semanales',
              permission: 'PRECIOS_COMPONENTES_PROMEDIO_SEMANAL-VER',
            },
            {
              name: 'Precio Fijo Semanal',
              icon: "fa-solid fa-money-bill-1",
              url: '/mantenimiento/precios-fijos',
              permission: 'PRECIO_FIJO_SEMANAL-VER',
            },
            {
              name: 'Precio Fijo Vigencia',
              icon: "fa-regular fa-money-bill-1",
              url: '/mantenimiento/precios-fijos-vigencias',
              permission: 'PRECIO_FIJO_VIGENCIA-VER',
            },
          ],
        },
        {
          name: 'Premio de Lealtad y Continuidad',
          icon: "fa-solid fa-award",
          url: '/mantenimiento/precio-lealtad-continuidad',
          permission: 'PREMIO_LEALTAD_CONTINUIDAD-VER',
        },
        {
          name: 'Mantenimiento Exclusión Premio Clase A',
          icon: "fa-solid fa-award",
          url: '/catalog/premiosProductividad',
          permission: 'EXCLUSION_PREMIO_CLASE_A-VER',
        },
        {
          name: 'Premio Clase A ',
          icon: "fa-solid fa-award",
          url: '/liquidacion/premioClaseA',
          permission: 'PREMIO_CLASE_A-VER',
        },
        {
          name: 'Premio Fidelidad ',
          icon: "fa-solid fa-award",
          url: '/liquidacion/premioFidelidad',
          permission: 'PREMIO_CLASE_A-VER',
        },
        {
          name: 'Controles SIRLA',
          url: '/catalog/mantenimientoControles',
          icon: "fa-solid fa-gear",
          permission: 'CONTROLES_SIRLA-VER',
        },
        {
          name: 'Incidencias Individual',
          url: '/capturas/incidencias-individual',
          icon: "fa-regular fa-square",
          permission: 'INCIDENCIA_INDIVIDUAL-VER',
        },
        {
          name: 'Incidencias por Lote',
          url: '/Captura/Incidencias/Lotes',
          icon: "fa-solid fa-border-all",
          permission: 'INCIDENCIA_LOTES-VER',
        },
        {
          name: 'Compensación Logistica',
          icon: "fa-solid fa-truck-plane",
          url: '/catalog/compensacionLogistica',
          permission: 'COMPENSACION_LOGISTICA-VER',
        },
        {
          name: 'Precios Premios Pecuarios',
          icon: "fa-solid fa-shield-dog",
          url: '/calidad/precios-premios-pecuarios',
          permission: 'PRECIOS_PREMIOS_PECUARIOS-VER',
        },
        {
          name: 'Formulas de Calidad',
          icon: "fa-solid fa-square-root-variable",
          url: '/calidad/formulas-calidad',
          permission: 'FORMULAS_CALIDAD-VER',
        },
      ]
    },

    {
      name: 'RECOLECCIÓN',
      icon: "fa-solid fa-truck",
      children: [
        {
          name: 'Sistema Transferencia Recoleccion',
          icon: "fa-solid fa-list",
          url: '/reco',
          permission: 'RECOLECCION-VER',
        },
        {
          name: 'Recolección',
          icon: "fa-solid fa-truck",
          url: '/Captura/recoleccion',
          permission: 'RECOLECCION-VER',
        },
        {
          name: 'Detalle de Recolección de Leche',
          icon: "fa-solid fa-road-bridge",
          url: '/catalog/recoleccion-leche',
          permission: 'DETALLES_RECOLECCION-VER',
        },
        {
          name: 'Ajuste de Recolección',
          icon: "fa-solid fa-truck-ramp-box",
          url: '/catalog/controlReco',
          permission: 'AJUSTES_RECOLECCION-VER',
        },
        {
          name: 'Correcciones Ruta',
          icon: "fa-solid fa-shuffle",
          url: '/catalog/correcciones-ruta',
          permission: 'CORRECCIONES_RUTA-VER',
        },
        {
          name: 'Volantes y Etiquetas Especiales',
          icon: "fa-solid fa-file-lines",
          url: '/Captura/Recolecciones/Volantes',
          permission: 'VOLANTES_ETIQUETAS_ESPECIALES-VER',
        },]
    },

    {
      name: 'CALIDAD',
      icon: 'fa-solid fa-star',
      children: [
        {
          name: 'Generación de Etiquetas Pipas',
          icon: "fa-solid fa-print",
          url: '/calidad/generacion-etiquetas-pipas',
          permission: 'ETIQUETAS_PIPAS-VER',
        },
        {
          name: 'Ponderación por Ruta',
          icon: "fa-solid fa-xmarks-lines",
          url: '/calidad/ponderacion-ruta',
          permission: 'PONDERACION_RUTA-VER',
        },
        {
          name: 'Captura Análisis',
          url: '/calidad/mantenimiento-analisis',
          icon: "fa-solid fa-chart-bar",
          permission: 'CAPTURA_ANALISIS-VER',
        },
        {
          name: 'Carga Milko Scan',
          icon: "fa-solid fa-upload",
          url: '/calidad/carga-milko-scan',
          permission: 'CARGA_MILKOSCAN-VER',
        },
        {
          name: 'Captura Análisis Pipas',
          icon: "fa-solid fa-trailer",
          url: '/calidad/captura-analisis-pipas',
          permission: 'CAPTURA_ANALISIS_PIPAS-VER',
        },
        {
          name: 'Cierre Diario y Semanal',
          icon: "fa-solid fa-calendar-xmark",
          url: '/calidad/cierre-diario-semanal',
          permission: 'CIERRE_DIARIO_SEMANAL-VER',
        },
        {
          name: 'Etiquetas de Coliformes y LPC',
          icon: "fa-solid fa-note-sticky",
          url: '/calidad/etiquetas-coliformes-lpc',
          permission: 'ETIQUETAS_COLIFORMES_LPC-VER',
        },
        {
          name: 'Carga de Coliformes y LPC',
          icon: "fa-solid fa-arrow-up",
          url: '/calidad/carga-coliformes-lpc',
          permission: 'CARGAS_COLIFORMES_LPC-VER',
        },
        {
          name: 'Relación de Análisis por Fecha',
          icon: "fa-solid fa-arrows-left-right-to-line",
          url: '/calidad/relacion-analisis-fecha',
          permission: 'RELACION_ANALISIS_FECHAS-VER',
        },
        {
          name: 'Análisis de Leche por Tanque',
          icon: "fa-solid fa-ranking-star",
          url: '/calidad/analisis-leche-tanque',
          permission: 'ANALISIS_LECHE_TANQUE-VER',
        },
        {
          name: 'Índices de Calidad',
          icon: "fa-solid fa-star",
          url: '/calidad/indices-calidad',
          permission: 'INDICES_CALIDAD-VER',
        },
        {
          name: 'Reporte de Trazabilidad',
          icon: "fa-solid fa-file-pdf",
          url: '/calidad/reporte-trazabilidad',
          permission: 'REPORTES_TRAZABILIDAD-VER',
        },
      ]
    },
    {
      name: 'PECUARIOS',
      icon: "fa-solid fa-cow",
      children: [
        {
          name: 'Mantenimiento Premios Pecuarios',
          icon: "fa-solid fa-users",
          url: '/calidad/premios-pecuarios',
          permission: 'MANTENIMIENTO_PREMIOS_PECUARIOS-VER',
        },
      ]
    },

    {
      name: 'PROCESOS',
      icon: 'fa-solid fa-clipboard-list',
      children: [
        {
          name: 'Calcula Liquidación',
          icon: "fa-solid fa-calculator",
          url: '/procesos/calculaLiquidaciones',
          permission: 'CALCULA_LIQUIDACION-VER',
        },
        {
          name: 'Previa',
          icon: "fa-solid fa-calculator",
          url: '/procesos/consultaLiquidacionPrevia',
          permission: 'LIQUIDACION_PREVIA-VER',
        },
        {
          name: 'Definitiva',
          icon: "fa-solid fa-lock",
          url: '/procesos/consultaLiquidacionDefinitiva',
          permission: 'LIQUIDACION_DEFINITIVA-VER',
        },
        {
          name: 'Por concepto',
          icon: "fa-solid fa-rectangle-list",
          url: '/procesos/consultaLiquidacion',
          permission: 'LIQUIDACION_CONCEPTO-VER',
        },
        {
          name: ' Consecutiva ',
          icon: "fa-solid fa-list-ol",
          url: '/procesos/consultaLiquidacionConsecutivo',
          permission: 'LIQUIDACION_CONSECUTIVA-VER',
        },
        {
          name: 'Autoriza Liquidaciones',
          icon: "fa-solid fa-check-to-slot",
          url: '/procesos/autorizaLiquidaciones',
          permission: 'AUTORIZA_LIQUIDACION-VER',
        },
        {
          name: 'Cierre Semanal',
          icon: "fa-solid fa-calendar-check",
          url: '/procesos/cierreSemanal',
          permission: 'CIERRE_SEMANAL-VER',
        },
        {
          name: 'Reversa Liquidación',
          icon: "fa-solid fa-angles-left",
          url: '/procesos/reversaLiquidacion',
          permission: 'REVERSA_LIQUIDACION-VER',
        },
        {
          name: 'Transferencia Unión Crédito',
          icon: "fa-regular fa-file-lines",
          url: '/procesos/transferenciaunioncredito',
          permission: 'TRANSFERENCIA_UNION_CREDITO-VER',
        },

      ]
    },
    {
      name: 'CONSULTAS',
      icon: 'fa-solid fa-magnifying-glass',
      children: [
        {
          name: 'Comparativo Recolección vs Análisis',
          icon: "fa-regular fa-equals",
          url: '/calidad/comparativo-recoleccion-analisis',
          permission: 'RECOLECCION_VS_ANALISIS-VER',
        },
        {
          name: 'Direcciones de Socios',
          icon: "fa-regular fa-address-book",
          url: '/calidad/direcciones-socios',
          permission: 'DIRECCIONES_SOCIOS-VER',
        },
        {
          name: 'Controles Internos',
          icon: "fa-solid fa-list-check",
          url: '/Reportes/control-interno',
          permission: 'CONTROLES_INTERNOS-VER',
        },
        {
          name: 'Deducciones',
          icon: "fa-regular fa-dollar-sign",
          url: '/calidad/consulta-deducciones',
          permission: 'DEDUCCIONES-VER',
        },
      ]
    },

    {
      name: 'REPORTES',
      icon: 'fa-solid fa-file-pdf',
      children: [
        {
          name: 'Litros Recolectados',
          url: '/Reportes/Recolección/Litros',
          permission: 'LITROS_RECOLECTADOS-VER',
        },
        {
          name: 'Resumen de Recolección',
          url: '/Reportes/Recolección/resumenDeRecoleccion',
          permission: 'RESUMEN_RECOLECCION-VER',
        },
        {
          name: 'Impresión Liquidación',
          url: '/Reportes/Recolección/recoleccionImpresionLiquidacion',
          permission: 'IMPRESION_LIQUIDACION-VER',
        },
        {
          name: 'Desglose de liquidación',
          url: '/Reportes/Recolección/Liquidacio-X-Proveedor',
          permission: 'DESGLOSE_LIQUIDACION-VER',
        },
        {
          name: 'Relacion Facturas Socios',
          url: 'contabilidad/relacion-facturas',
          permission: 'RELACION_FACTURA_SOCIOS-VER',
        },
        {
          name: 'Concentrado de litros Mensual',
          url: '/Reportes/Recolección/LitrosImportes1',
          permission: 'CONCENTRADO_LITROS_MENSUAL-VER',
        },
        {
          name: 'Concentrado de litros Anual',
          url: '/Reportes/Recolección/LitrosImportes2',
          permission: 'CONCENTRADO_LITROS_ANUAL-VER',
        },
        {
          name: 'Relación de Pago',
          url: '/Reportes/relacionDePago',
          permission: 'RELACION_PAGO-VER',
        },
        {
          name: 'Leche en Transito Ultimo Día del Mes',
          url: '/catalog/leche-transito-ultDia',
          permission: 'LECHE_TRANSITO_ULTIMO_DIA_MES-VER',
        },
        {
          name: 'Leche en Transito Ultimos Días del Mes',
          url: '/catalog/leche-transit-last-days',
          permission: 'LECHE_TRANSITO_ULTIMOS_DIAS_MES-VER',
        },
        {
          name: 'Desvios de Leche',
          url: '/Reportes/Recolección/Desvio-Leche',
          permission: 'DESVIO_LECHES-VER',
        },
        {
          name: 'Conciliacion Leche en Transito',
          url: '/Reportes/Recolección/LitrosTransito',
          permission: 'CONCILIACION_MES_LECHE_TRANSITO-VER',
        },
        {
          name: 'Conciliacion Mes Leche en Transito',
          url: '/Reportes/transitoLeche',
          permission: 'CONCILIACION_MES_LECHE_TRANSITO-VER',
        },
        {
          name: 'Acciones y Topes',
          url: '/Reportes/accionesTopes',
          permission: 'ACCIONES_TOPES-VER',
        },
        {
          name: 'Rutas pagadas',
          url: '/Reportes/rutasPagadas',
          permission: 'LITROS_RECOLECTADOS-VER',
        },

      ]
    },
    {
      name: 'CONFIGURACIÓN',
      icon: 'fa-solid fa-gears',
      children: [
        {
          name: 'Usuarios',
          icon: "fa-solid fa-users",
          url: '/catalog/usuarios',
          permission: 'ADMINISTRADOR-TODO',
        },
        {
          name: 'Perfiles',
          icon: "fa-regular fa-id-card",
          url: '/catalog/permisos-por-rol',
          permission: 'ADMINISTRADOR-TODO',
        },
        {
          name: 'Juego de valores',
          icon: "fa-solid fa-list",
          url: '/catalog/otros-catalogos',
          permission: 'ADMINISTRADOR-TODO',
        },
      ]
    },
  ];

  constructor(private permissionsService: PermissionsService) {
    this.validatePermission(this.menuItems)
  }

  validatePermission(menu: any[]) {
    for (let index = menu.length-1; index >= 0; index--) {
      const item = menu[index];
      if (!!item.children && item.children.length > 0) {
        this.validatePermission(item.children)
      }
      if (!!item.permission) {
        if (!this.permissionsService.hasPermission(item.permission)) {
          menu.splice(index, 1);
        }
      }
    }
  }

  public getMenus(): Array<INavData> {
    return this.menuItems;
  }
}
